<template>
    <pm-custom-dialog v-if="visible" v-model="visible" :onClose="onClose">
        <div style="display: flex; height: 100%; flex-direction: column; justify-content: space-between; background: url('https://cdn.denticalc.com/images/unlock.jpg'); background-repeat: no-repeat; background-size: cover;">
            <!-- <div style="margin-bottom: 16px; text-align: center;" v-if="title!==''">
                <h2 style="font-size: 18px; line-height: 1.2; font-weight: 600; text-shadow: 0.5px 0.5px 0 #000;" v-html="title"></h2>
            </div> -->

            <div style="flex-grow: 1;"></div>

            <div style="line-height: 1.3; display: block; position: relative; font-size: 15px; margin-bottom: 0px; padding: 0 16px 40px 16px;">

                <!-- <pm-premium-features-list :price="fullPriceNum" :currency="currency" /> -->

                <div style="text-align:left; padding: 0 20px; font-weight: 900; font-size: 32px; line-height: 1.1; ">
                    <br/>
                    I'm sure you<br/>
                    love DentiCalc
                </div>

                <!----<pm-reviews-slider />-->

                <pm-features-table />


                <template v-if="productsLoaded">
                    <!-- <h3 class="shimmer" style="text-shadow: 2px 2px 2px rgba(0,0,0,.2);font-size: 36px; font-weight: 900; margin: 10px 0 0px 0; padding: 0;">-90% OFFER</h3> -->
                    <!-- <strike style="font-size: 18px; display: inline-block; margin-right: 10px; font-weight: 600;">{{ fullPrice }}</strike> -->
                    <!-- <br/> -->

                    <!-- <template v-if="!isPremiumUsed">only
                        <span v-if="$isIOS()" style="font-weight: 900; font-size: 18px;">{{introPrice}} <small>for the first month</small></span>
                        <span v-else style="font-weight: 900; font-size: 18px;">{{introPrice}} <small>for the first month</small></span>
                        <br/>then&nbsp;
                    </template> -->
                    <!-- <template>
                        Now only <span style="font-size: 18px; display: inline-block; margin-right: 10px; font-weight: 900;">{{ origPrice }}</span>
                        <small>/month</small>
                    </template> -->

                    <div style="font-size: 22px; line-height: 1; margin-top: 10px;">
                        <!-- <h3 class="shimmer" style="text-shadow: 2px 2px 2px rgba(0,0,0,.2);font-size: 28px; font-weight: 900; margin: 10px 0 10px 0; padding: 0;">SPECIAL OFFER</h3> -->
                        <span style="font-weight: 300;"><small>Only</small><span style="font-weight: 900"> {{origPrice}}</span><small> / month</small></span>
                        <br/>
                        <small style="font-size: 12px;">No risk, cancel anytime on <span v-if="$isIOS()">the App Store</span><span v-if="!$isIOS()">Google Play</span></small>
                    </div>

                </template>

                <pm-iap-product-button :sku="selectedSku" overrideTitle="UPGRADE NOW" style="margin: 32px auto 0 auto;" @click="logSubscribeClick" />

                <!-- <div style="padding: 20px">
                    <div style="line-height: 1.3; font-size: 13px;">
                        {{ $t('payment.cancel_subscription') }}
                        {{ $t('subscriptions.subscription_description') }}
                        <pm-privacy-links />
                    </div>
                </div> -->
                <!-- <br/>
                <small>No risk, cancel anytime on <span v-if="$isIOS()">the App Store</span><span v-if="!$isIOS()">Google Play</span></small> -->

                <!-- <span class=" support-btn button__restore" style="font-weight: 600;" @click="gotoSubscriptionsAndRestorePurchases">
                    Restore purchases
                </span> -->
            </div>
        </div>
    </pm-custom-dialog>
</template>
<style>
.shimmer {

  background: #000 -webkit-gradient(linear, 100% 0, 0 0, from(#000), color-stop(0.5, #ffffff), to(#000));
  background-position: -12rem top; /*50px*/
  background-repeat: no-repeat;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  -webkit-animation-name: shimmer;
  -webkit-animation-duration: 2.2s;
  -webkit-animation-iteration-count: 1;
  -webkit-background-size: 12rem 100%; /*50px*/

}

@-webkit-keyframes shimmer {
    0% {
        background-position: -6rem top; /*50px*/
    }

    70% {
        background-position: 18.5rem top; /*200px*/
    }

    100% {
        background-position: 18.5rem top; /*200px*/
    }
}
</style>
<script>
import PmCustomDialog from "./base-dialog.vue";
import PmPremiumFeaturesList  from "./premium-features-list.vue";
import PmIapProductButton from "@/components/core/iap-product-button.vue";
import PmPrivacyLinks from "../addons/privacy-links";
import { isDiscountEligible } from "@/utils/promo-offer";
import PmReviewsSlider from "./reviews-slider.vue";
import PmFeaturesTable from "./premium-features-table.vue";
export default {
    components: {
        PmCustomDialog,
        PmPremiumFeaturesList,
        PmIapProductButton,
        PmPrivacyLinks,
        PmReviewsSlider,
        PmFeaturesTable
    },
    props: {
        dialogData: {
            type: Object,
            default: () => ({}),
        }
    },
    data: () => ({
        visible: false,
        selectedSku: window.IAP.getDefaultSku(),
        origPrice: "",
        introPriceNum: 0,
        origPriceNum: 0,
        fullPrice: "",
        fullPriceNum: 0,
        introPrice: "",
        productsLoaded: window.IAP.status.includes('offeringsLoaded'),
        isPremiumUsed: true,
        currency: "",
    }),
    created() {

        this.$bus.$on("flutter:onOfferingsUpdated", () => {
            this.init();
        });

        if (window.IAP.status.includes('offeringsLoaded')) {
            this.init();
        }

        this.registerBusEvent('subscribe:process', this.changeProcessStatus);
    },
    computed: {
        title() {
            if (typeof this.dialogData.title !== 'undefined') return this.dialogData.title;
            return "This feature is available in";
        },
    },
    methods: {
        init() {
            let product = IAP.getProduct(this.selectedSku);
            console.log(product);
            // if (product.currencyCode.toUpperCase() === "INR") {
                this.selectedSku = window.IAP.getDefaultSku();
                product = IAP.getProduct(this.selectedSku);
            // }

            this.origPriceNum = IAP.getProductPrices(product, true);
            this.origPrice = IAP.getProductPrices(product);

            this.introPriceNum = IAP.getIntroPrice(product, true);
            this.introPrice = IAP.getIntroPrice(product);

            this.productsLoaded = true;
            //this.isPremiumUsed = this.selectedSku !== "full_access_monthly_sale" || IAP.hasPreviousPurchase(this.selectedSku);
            this.isPremiumUsed = true;

            this.fullPriceNum = this.getFullPrice(product);
            this.fullPrice =  this.fullPriceNum + ' ' + product.currencyCode;

            this.currency = product.currencyCode;
        },
        getFullPrice(product) {
            let full = 0;
            let hasDecimals = parseInt(product.priceAsString) !== parseFloat(product.priceAsString);
            const multiplier = this.isPremiumUsed ? 10 : 10;
            full = parseFloat((parseFloat(product.priceAsString) * 10).toFixed(2)) + 0;
            return hasDecimals ? full.toFixed(2) : full;
        },
        logSubscribeClick() {
            window.Tracker.logEvent({
                event_name: "subscribe_click",
                event_category: "iap",
                event_label: "premium",
            });


            if (typeof this.dialogData.referrer) {
                window.Tracker.logEvent({
                    event_name: "premium_buy",
                    event_category: "iap",
                    event_label: this.dialogData.referrer,
                });
            }
        },
        changeProcessStatus(data) {
            this.visible = Boolean(data);
        },
        show() {
            this.visible = true;
            this.logDialogView();

            if (typeof this.dialogData.referrer) {
                window.Tracker.logEvent({
                    event_name: "premium_show",
                    event_category: "iap",
                    event_label: this.dialogData.referrer,
                });
            }

        },
        close() {
            this.visible = false;
            this.$emit('close');
        },
        logDialogView() {
            const interestedToUpgrade = parseInt(localStorage.getItem('interestedToUpgrade') || '0', 10) + 1;

            localStorage.setItem('interestedToUpgrade', String(interestedToUpgrade));

            window.Tracker.logEvent({
                event_label: 'interestedToUpgrade',
                event_name: 'interested_to_upgrade',
                event_value: interestedToUpgrade,
            });
        },
        async gotoSubscriptionsAndRestorePurchases() {
            const params = {task: 'restore_purchases'};

            try {
                await this.goToRoute('addons', params);
            } catch (error) {
                captureException(error);
            }
        },

        onClose() {
            // this.$bus.$emit('openAppDialog','extraTrialOffer');
            //const dialog = localStorage.getItem('storeCancelReason') ? 'priceWorthIt' : 'storeCancelDialog';
            let counter = localStorage.getItem('storeCancelDialogCounter') || 0;
            // if (counter === 0 || counter % 3 === 0) this.$bus.$emit('openAppDialog','priceWorthIt');
            localStorage.setItem('storeCancelDialogCounter', ++counter);
            //this.$bus.$emit('openAppDialog',dialog);
        },

        async goToRoute(routeName, params = null) {
            this.close();
            await this.$router.push({name: routeName, params});
        },
    }
}
</script>
